import PriceQuotesPageFilters from './PriceQuotesPageFilters';

export default PriceQuotesPageFilters;
